module.exports = __webpack_public_path__ + "static/gallery-vote-86a0b8b173ebe12346eb76b2e1a1c9e5.png";